import React from 'react';
import { Box, Divider, Stack, Typography } from '@mui/material';
import { buttonHoverHandlers, commonStyles } from '../styles/commonStyles';

interface LoginSectionProps {
  onAuthenticate: () => void;
}

const LoginSection: React.FC<LoginSectionProps> = ({ onAuthenticate }) => {
  return (
    <Box sx={commonStyles.sectionContainer}>
      <Stack spacing={3} alignItems="center" sx={commonStyles.contentStack}>
        {/* Title */}
        <Typography variant="h4" sx={commonStyles.sectionTitle}>
          Welcome Back
        </Typography>

        {/* Description */}
        <Typography
          variant="body1"
          textAlign="center"
          sx={commonStyles.descriptionText}
        >
          Please sign in to submit new requests, review previously submitted
          requests, or respond to assigned workflows.
        </Typography>

        <Divider sx={{ my: 1, width: '100%' }} />

        {/* Styled Sign In Button */}
        <button
          style={commonStyles.primaryButton}
          onMouseOver={buttonHoverHandlers.primaryButtonHover}
          onMouseOut={buttonHoverHandlers.primaryButtonLeave}
          onClick={onAuthenticate}
        >
          Sign In
        </button>
      </Stack>
    </Box>
  );
};

export default LoginSection;
